import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

import { useAppDispatch, useAppSelector } from "app/redux-store-interactions";
import { featuresConfig } from "config/features";
import { pointLineActions } from "features/pointLine";
import { Picker, renderActions, selectPicker } from "features/render";
import { selectEnabledWidgetKeys } from "slices/explorer";

import { ActiveIcon } from "./activeIcon";
import { ListItemTextWithHotkey } from "./listItemTextWithHotkey";

export function MeasureMenu({ onSelect }: { onSelect?: () => void }) {
    const activePicker = useAppSelector(selectPicker);
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const enabledWidgets = useAppSelector(selectEnabledWidgetKeys);

    const togglePicker = (picker: Picker) => {
        dispatch(renderActions.setPicker(picker === activePicker ? Picker.Object : picker));
        onSelect?.();
    };

    return (
        <>
            {enabledWidgets.has(featuresConfig.measure.key) && (
                <MenuItem onClick={() => togglePicker(Picker.Measurement)}>
                    <ListItemIcon>
                        <ActiveIcon Icon={featuresConfig.measure.Icon} active={activePicker === Picker.Measurement} />
                    </ListItemIcon>
                    <ListItemText>{t("measure")}</ListItemText>
                </MenuItem>
            )}
            {enabledWidgets.has(featuresConfig.area.key) && (
                <MenuItem onClick={() => togglePicker(Picker.Area)}>
                    <ListItemIcon>
                        <ActiveIcon Icon={featuresConfig.area.Icon} active={activePicker === Picker.Area} />
                    </ListItemIcon>
                    <ListItemText>{t("area")}</ListItemText>
                </MenuItem>
            )}
            {enabledWidgets.has(featuresConfig.outlineLaser.key) && (
                <MenuItem onClick={() => togglePicker(Picker.OutlineLaser)}>
                    <ListItemIcon>
                        <ActiveIcon
                            Icon={featuresConfig.outlineLaser.Icon}
                            active={activePicker === Picker.OutlineLaser}
                        />
                    </ListItemIcon>
                    <ListItemTextWithHotkey hotkey="L">{t("laser")}</ListItemTextWithHotkey>
                </MenuItem>
            )}
            {enabledWidgets.has(featuresConfig.manhole.key) && (
                <MenuItem onClick={() => togglePicker(Picker.Manhole)}>
                    <ListItemIcon>
                        <ActiveIcon Icon={featuresConfig.manhole.Icon} active={activePicker === Picker.Manhole} />
                    </ListItemIcon>
                    <ListItemText>{t("manhole")}</ListItemText>
                </MenuItem>
            )}
            {enabledWidgets.has(featuresConfig.pointLine.key) && (
                <MenuItem
                    onClick={() => {
                        togglePicker(Picker.PointLine);
                        if (activePicker !== Picker.PointLine) {
                            dispatch(pointLineActions.newPointLine());
                        }
                    }}
                >
                    <ListItemIcon>
                        <ActiveIcon Icon={featuresConfig.pointLine.Icon} active={activePicker === Picker.PointLine} />
                    </ListItemIcon>
                    <ListItemTextWithHotkey hotkey="P">{t("pointLine")}</ListItemTextWithHotkey>
                </MenuItem>
            )}
        </>
    );
}
